import { render, staticRenderFns } from "./ApproveTaskList.vue?vue&type=template&id=73848097&scoped=true"
import script from "./ApproveTaskList.vue?vue&type=script&lang=js"
export * from "./ApproveTaskList.vue?vue&type=script&lang=js"
import style0 from "./ApproveTaskList.vue?vue&type=style&index=0&id=73848097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73848097",
  null
  
)

export default component.exports